import {cardToCardService, cardToCardWalletService} from "@/common/api.service"
import {cardToCardStatus} from "@/constants/cardToCard"

const initialStates = {
    status: 'loading',
    setting_status: 'loading',
    setting: {},
    recharge_result_data: {},
    wallet_status: 'loading',
    wallet: {},
    recharge_result_status: 'loading',
    recharge_wallet_result_data: {},
    recharge_wallet_result_status: 'loading',
    card_to_cards: [],
    form_data: {
        gateway_cards: []
    }
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    rechargeResultStatusLoading(state) {
        state.recharge_result_status = 'loading'
    },
    rechargeWalletResultStatusLoading(state) {
        state.recharge_wallet_result_status = 'loading'
    },
    success(state, card_to_cards) {
        state.status = 'success'
        state.deposits = card_to_cards
    },
    fail(state) {
        state.status = 'fail'
        state.deposits = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key) {
            state.form_data[key] = ''
        });
    },
    rechargeData(state, recharge_result_data) {
        state.recharge_result_data = recharge_result_data
        state.recharge_result_status = 'success'
    },
    rechargeWalletData(state, recharge_result_data) {
        state.recharge_wallet_result_data = recharge_result_data
        state.recharge_wallet_result_status = 'success'
    },
    successWallet(state, wallet) {
        state.wallet_status = 'success'
        state.wallet = wallet
    },
    loadingSetting(state) {
        state.setting_status = 'loading'
    },
    settingSuccess(state, setting) {
        state.setting_status = 'success'
        state.setting = setting
    },
}

const getters = {
    status: ({status}) => status,
    card_to_cards: ({card_to_cards}) => card_to_cards,
    form_data: ({form_data}) => form_data,
    recharge_result_data: ({recharge_result_data}) => recharge_result_data,
    recharge_result_status: ({recharge_result_status}) => recharge_result_status,
    setting: ({setting}) => setting,
    setting_status: ({setting_status}) => setting_status,
    wallet_status: ({wallet_status}) => wallet_status,
    wallet: ({wallet}) => wallet,
    recharge_wallet_result_data: ({recharge_wallet_result_data}) => recharge_wallet_result_data,
    recharge_wallet_result_status: ({recharge_wallet_result_status}) => recharge_wallet_result_status,
    active_card_to_cards: ({card_to_cards}) => {
        if (card_to_cards.data) {
            return card_to_cards.data.filter(deposit =>
                card_to_cards.status === cardToCardStatus.ACTIVE
            )
        }

        return card_to_cards.filter(card_to_cards =>
            card_to_cards.status === cardToCardStatus.ACTIVE
        )
    }
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return cardToCardService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return cardToCardService.fetch(params).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchUserGateways({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return cardToCardService.fetch(params).then(response => {
            commit('success', response.data.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')

        return cardToCardService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    rechargeData({commit}, tracking_code) {
        commit('rechargeResultStatusLoading')
        return cardToCardService.getRechargeData(tracking_code).then(response => {
            commit('rechargeData', response.data.data)
        });
    },
    rechargeWalletData({commit}, tracking_code) {
        commit('rechargeWalletResultStatusLoading')
        return cardToCardWalletService.getRechargeData(tracking_code).then(response => {
            commit('rechargeWalletData', response.data.data)
        });
    },
    fetchWallet({commit}) {
        return cardToCardWalletService.getSettings().then(response => {
            commit('successWallet', response.data.data)
        })
    },
    fetchSetting({commit}, hashid) {
        commit('loadingSetting')
        return cardToCardService.fetchSetting(hashid).then(response => {
            commit('settingSuccess', response.data.data)
        })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}